import LandPlotSvg from '@assets/images/svg/land-plot.svg';
import React from 'react';
import { View } from 'react-native';

export interface LandPlotIconProps {
    size?: number;
    color?: string;
}

export function LandPlotIcon({ size = 19, color = '#1A1A1A' }: LandPlotIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <LandPlotSvg width={size} height={size} color={color} />
        </View>
    );
}

export default LandPlotIcon;
